// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control[data-v-f0e178b0]  .height-fit{height:37px}.v-select-is-invalid[data-v-f0e178b0]  .vs__dropdown-toggle{border:1px solid #ef5350!important}#bookingCode .vs__actions[data-v-f0e178b0]{display:none!important}", ""]);
// Exports
module.exports = exports;
